/* Copyright 2016-2022
   Kabandy
   Author: Alexis Tugilimana
 */

export default class Units {
    constructor() {}

    static getUnitsSymbol(units) {
        const symbolUnits = {
            euro: "€",
            length: "m",
            surface: "m&sup2",
            volume: "m&sup3",
            object: "EA",
            percentdesc: "%",
            masskg: "kg",
            durationday: "d",
            pound: String.fromCharCode(163),
            dollar: "$",
            yen: String.fromCharCode(165),
            forint: "Ft"
        };
        return symbolUnits[units];
    }
}
